var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 47,
    viewBox: "0 0 62 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.5556 23.174L52.3601 7.82577H37.0695L22.9044 23.174L44.5344 46.4783H61.6084L38.5556 23.174Z",
    fill: "#4C4ED9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0528 23.3043L9.24829 38.6525H24.5388L38.704 23.3043L17.074 0H0L23.0528 23.3043Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a11ec5d3.svg";
export { ForwardRef as ReactComponent };